interface CustomRadioProps {
  name: string;
  value: string;
  label: string;
  checked: boolean;
  onChange: () => void;
}

export const CustomRadio = ({
  name,
  value,
  label,
  checked,
  onChange,
}: CustomRadioProps) => (
  <div className="inline-flex items-center">
    <label
      className="relative flex items-center p-2 rounded-full cursor-pointer"
      htmlFor={`${name}-${value}`}
    >
      <input
        type="radio"
        name={name}
        id={`${name}-${value}`}
        value={value}
        className="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-full border border-primary xl:border-gray-200 text-primary transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:border-gray-500 before:bg-transparent before:opacity-0 before:transition-opacity checked:border-cyan-500 checked:before:bg-cyan-500 hover:before:opacity-10"
        checked={checked}
        onChange={onChange}
      />
      <span className="absolute text-primary transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3.5 w-3.5"
          viewBox="0 0 16 16"
          fill="currentColor"
        >
          <circle data-name="ellipse" cx="8" cy="8" r="8" />
        </svg>
      </span>
    </label>
    <label
      htmlFor={`${name}-${value}`}
      className="xl:text-base font-medium text-gray-600 ml-2 cursor-pointer"
    >
      {label}
    </label>
  </div>
);
